import { createContext } from 'react';
let CartContext = createContext();
export default CartContext;
